/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-19",
    versionChannel: "nightly",
    buildDate: "2025-01-19T00:06:53.254Z",
    commitHash: "3c71ed2aca0769d48492579c3bd919b07ed9a55c",
};
